/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Deserializable } from '@app/shared/models/deserializable.interface';
import { DateTime } from '@app/shared/models/date-time.model';

export enum LaravelModelsEnum {
  USER = 'App\\Models\\User',
  COUNTRY = 'App\\Models\\Country',
  CITY = 'App\\Models\\City',
  HOTEL = 'App\\Models\\Hotel',
  SALE = 'App\\Models\\Sale',
  SALE_OFFER = 'App\\Models\\SaleOffer',
  SALE_FINAL = 'App\\Models\\SaleFinal',
  SALE_FINAL_ITEM = 'App\\Models\\SaleFinalItem',
  CLIENT = 'App\\Models\\Client',
  COMPANY = 'App\\Models\\Company',
  ENQUIRY = 'App\\Models\\Enquiry',
  INVOICE = 'App\\Models\\Invoice',
  PAYMENT = 'App\\Models\\Payment',
  BOOKING = 'App\\Models\\HotelBooking',
  HOTELBOOKING = 'App\\Models\\HotelBooking',
  HOTELBOOKINGCANCELLATION = 'App\\Models\\HotelBookingCancellation',
  EVENT = 'App\\Models\\EVENT',
  EVENTGROUP = 'App\\Models\\EventGroup',
  COMMENT = 'App\\Models\\Comment',
  VENUE = 'App\\Models\\Venue',
  BANK_ACCOUNT = 'App\\Models\\BankAccount',
}

export class Model implements Deserializable {
  created_at: DateTime;
  updated_at: DateTime;
  deleted_at: DateTime;

  deserialize(input: any): this {
    Object.assign(this, input);

    if (input.created_at && !(input.created_at instanceof DateTime)) {
      this.created_at = new DateTime().deserialize(input.created_at);
    }

    if (input.updated_at && !(input.updated_at instanceof DateTime)) {
      this.updated_at = new DateTime().deserialize(input.updated_at);
    }

    if (input.deleted_at && !(input.deleted_at instanceof DateTime)) {
      this.deleted_at = new DateTime().deserialize(input.deleted_at);
    }

    return this;
  }
}
